import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_HOME_PAGE } from "@/settings/constant";
import { Button, Tag, Typography } from "@bookips/sds";
import Link from "next/link";
import Image from "next/image";
const BrandCard = (param)=>{
    let { onCouponClick , className , imageClassName , imageRounded , infoClassName , sampleButton , ...brand } = param;
    const { isMobile  } = useWindowDimensions();
    const brandHomeHref = brand.brandName ? BRAND_HOME_PAGE(brand.brandName) : null;
    const ImageArea = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cn("relative h-full w-full overflow-hidden", imageRounded && "rounded-md"),
                children: brand.brandMainImageUrl && /*#__PURE__*/ _jsx(Image, {
                    src: brand.brandMainImageUrl,
                    alt: "brand",
                    fill: true,
                    className: "object-cover"
                })
            }),
            brand.brandLogoImageUrl && /*#__PURE__*/ _jsx("div", {
                className: "absolute right-3 bottom-[-20px] flex items-center justify-center rounded-full bg-white p-1.5 max-sm:bottom-[-16px] max-sm:p-1",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "relative h-10 w-10 overflow-hidden rounded-full max-sm:h-8 max-sm:w-8",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: brand.brandLogoImageUrl,
                        alt: "brand logo",
                        fill: true
                    })
                })
            })
        ]
    });
    var _brand_getCouponBtnName;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex w-[340px] min-w-[300px] shrink-0 flex-col bg-white max-sm:w-[200px]", className),
        children: [
            brandHomeHref ? /*#__PURE__*/ _jsx(Link, {
                href: brandHomeHref,
                className: cn("relative h-[200px] w-full max-sm:h-[140px]", imageClassName),
                children: ImageArea
            }) : /*#__PURE__*/ _jsx("div", {
                className: cn("relative h-[200px] w-full max-sm:h-[140px]", imageClassName),
                children: ImageArea
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn("flex flex-col gap-8 px-2 pt-4 pb-2 max-sm:gap-6 max-sm:px-1.5", infoClassName),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col gap-1",
                        children: brand.authorName && (brandHomeHref ? /*#__PURE__*/ _jsx(Link, {
                            href: brandHomeHref,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: "text-primary max-sm:typo-subtitle1 hover:underline",
                                children: brand.authorName
                            })
                        }) : /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            className: "text-primary max-sm:typo-subtitle1",
                            children: brand.authorName
                        }))
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-1",
                                children: [
                                    brand.badgeText && /*#__PURE__*/ _jsx(Tag, {
                                        color: "red",
                                        size: isMobile ? "sm" : "md",
                                        bold: true,
                                        className: "bg-status-error text-white",
                                        children: brand.badgeText
                                    }),
                                    brand.tagText && /*#__PURE__*/ _jsx(Tag, {
                                        color: "gray",
                                        size: isMobile ? "sm" : "md",
                                        bold: true,
                                        children: "#".concat(brand.tagText)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col gap-2",
                                children: [
                                    (sampleButton === null || sampleButton === void 0 ? void 0 : sampleButton.show) && /*#__PURE__*/ _jsx(Button, {
                                        variant: "stroke",
                                        color: "secondary",
                                        size: isMobile ? "md" : "lg",
                                        className: "max-sm:typo-subtitle2 h-12 w-full max-sm:h-10 max-sm:gap-1 max-sm:px-3",
                                        onClick: sampleButton === null || sampleButton === void 0 ? void 0 : sampleButton.onClick,
                                        children: sampleButton === null || sampleButton === void 0 ? void 0 : sampleButton.label
                                    }),
                                    brand.useGetCouponBtn && /*#__PURE__*/ _jsx(Button, {
                                        variant: "fill",
                                        color: "secondary",
                                        size: isMobile ? "md" : "lg",
                                        className: "max-sm:typo-subtitle2 h-12 w-full max-sm:h-10 max-sm:gap-1 max-sm:px-3",
                                        onClick: onCouponClick,
                                        children: (_brand_getCouponBtnName = brand.getCouponBtnName) !== null && _brand_getCouponBtnName !== void 0 ? _brand_getCouponBtnName : "할인 쿠폰 받기"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default BrandCard;
